/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetEventAdmin,
  FleetEventAdminCreateInput,
  FleetEventAdminsList,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Grant per-event admin/moderator role
 */
export const createFleetEventAdmin = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetEventAdminCreateInput: MaybeRefOrGetter<FleetEventAdminCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventAdminCreateInput = toValue(fleetEventAdminCreateInput);

      return axiosClient<FleetEventAdmin>(
      {url: `/fleets/${fleetSlug}/events/${slug}/admins`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventAdminCreateInput, signal
    },
      );
    }




export const getCreateFleetEventAdminMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventAdmin>>, TError,CreateFleetEventAdminMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEventAdmin>>, TError,CreateFleetEventAdminMutationVariables, TContext> => {

const mutationKey = ['createFleetEventAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEventAdmin>>, CreateFleetEventAdminMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  createFleetEventAdmin(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventAdminMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEventAdmin>>>
    export type CreateFleetEventAdminMutationBody = FleetEventAdminCreateInput
    export type CreateFleetEventAdminMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetEventAdminMutationVariables = {fleetSlug: string;slug: string;data: FleetEventAdminCreateInput}

    /**
 * @summary Grant per-event admin/moderator role
 */
export const useCreateFleetEventAdmin = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventAdmin>>, TError,CreateFleetEventAdminMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEventAdmin>>,
        TError,
        CreateFleetEventAdminMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetEventAdminMutationOptions(options), queryClient);
    }
    /**
 * @summary List event admins
 */
export const fleetEventAdmins = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventAdminsList>(
      {url: `/fleets/${fleetSlug}/events/${slug}/admins`, method: 'GET', signal
    },
      );
    }




export const getFleetEventAdminsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'events',slug,'admins'
    ] as const;
    }


export const getFleetEventAdminsQueryOptions = <TData = Awaited<ReturnType<typeof fleetEventAdmins>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEventAdmins>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetEventAdminsQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetEventAdmins>>> = ({ signal }) => fleetEventAdmins(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetEventAdmins>>, TError, TData>
}

export type FleetEventAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetEventAdmins>>>
export type FleetEventAdminsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List event admins
 */

export function useFleetEventAdmins<TData = Awaited<ReturnType<typeof fleetEventAdmins>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEventAdmins>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetEventAdminsQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Revoke per-event admin/moderator role
 */
export const destroyFleetEventAdmin = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/events/${slug}/admins/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventAdminMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventAdmin>>, TError,DestroyFleetEventAdminMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventAdmin>>, TError,DestroyFleetEventAdminMutationVariables, TContext> => {

const mutationKey = ['destroyFleetEventAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEventAdmin>>, DestroyFleetEventAdminMutationVariables> = (props) => {
          const {fleetSlug,slug,id} = props ?? {};

          return  destroyFleetEventAdmin(fleetSlug,slug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventAdminMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEventAdmin>>>

    export type DestroyFleetEventAdminMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetEventAdminMutationVariables = {fleetSlug: string;slug: string;id: string}

    /**
 * @summary Revoke per-event admin/moderator role
 */
export const useDestroyFleetEventAdmin = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventAdmin>>, TError,DestroyFleetEventAdminMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEventAdmin>>,
        TError,
        DestroyFleetEventAdminMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetEventAdminMutationOptions(options), queryClient);
    }
